import { render } from "./SubrogationInfo.vue?vue&type=template&id=2a7b48bb&scoped=true"
import script from "./SubrogationInfo.vue?vue&type=script&lang=js"
export * from "./SubrogationInfo.vue?vue&type=script&lang=js"

import "./SubrogationInfo.vue?vue&type=style&index=0&id=2a7b48bb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7b48bb"]])

export default __exports__